<template>
    <label v-if="hasLable" :for="inputId" class="form-label">{{ $t(label) }}</label>
    <input v-model="model" :id="inputId" :name="name" :type="type" :placeholder="$t(placeholder)" :class="class" @input="onInput">
</template>

<script>
export default {
    props: {
        class: {
            type: String,
            default: "form-control"
        },
        value: {
            type: [String, Number],
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        hasLable: {
            type: Boolean,
            default: true
        },
        type: String,
        name: String,
        id: String, // Add the id prop
    },
    data() {
        return {
            inputId: this.id || this.name, // Use id prop if provided, else generate unique ID
            model: this.value
        };
    },
    methods: {
        onInput(evt) {
            console.log(evt);
        }
    },
    watch: {
        value: {
            handler(val) {
                this.model = val;
            },
            immediate: true
        } ,
        model: {
            handler(val) {
                this.$emit('input', val);
            },
        }
    }
};
</script>

<style scoped>
/* Add your component-specific styles here */
</style>
